import script from "./a-employee-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./a-employee-select.vue?vue&type=script&setup=true&lang=ts"

import "./a-employee-select.vue?vue&type=style&index=0&id=141c1add&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-141c1add"]])

export default __exports__